import platformConfigApiprod from './prod'; // prod

export default platformConfigApiprod;
